module.exports = __webpack_public_path__ + "static/media/img-hero-section-es.6cefc9f7.png";